export default {
  body: `
    How can the coronavirus vaccine protect your health?
  `,
  topic: `
    How the coronavirus vaccine can protect my health.
  `,
};
